module.exports = __webpack_public_path__ + "img/en.dc3a0dc7.png";